export default __webpack_public_path__ + "675d3eb3370c96307cbab26ecb3ca5d3.png";